import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.section`
  background-color: #000000;
  padding: 5% 6%;
  box-sizing: border-box;

  @media (min-width: 500px) {
    padding: 5% 12% 5% 12%;
  }
`;

const Subtitle = styled.h3`
  text-align: center;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.2em;
  color: #FFFF56;
  margin-bottom: 0px;

  @media (max-width: 500px) {
    font-size: 12px;
    line-height: 14px;
  }
`;

const Title = styled.h2`
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 52px;
  line-height: 35px;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  margin-bottom: 80px;


  @media (max-width: 500px) {
    font-size: 32px;
    line-height: 10px;
    margin-bottom: 40px;
  }
`;

const GoalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  position: relative; 

  @media (max-width: 500px) {
    flex-direction: row; 
    gap: 8px;


  }
`;

const GoalCard = styled.div`
  position: relative;
  flex: 1;
  max-width: calc(25% - 24px);
  background-color: #1F1F1F;
  border-radius: 30px;
  border: 1px solid #3F3F3F;
  overflow: hidden;
  margin-bottom: 24px;



  @media (max-width: 500px) {
    box-sizing: border-box;
    flex: 1 0 calc(50% - 8px);
    max-width: calc(50% - 8px);
    margin-bottom: 8px; 
 
  }

  &:hover {
    border: 1px solid #FFF56A;



  }


`;



const GoalImage = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
  margin-bottom: 0px;

  @media (max-width: 500px) {
   
    max-width: 100%; /* 調整圖片最大寬度 */
    height: auto; /* 確保高度按比例縮放 */
  }
`;


const GoalText = styled.p`
  font-size: 18px;
  line-height: 32px;
  color: #FFFFFF;
  align-items: flex-start;
  padding: 0px 24px 36px 24px;
  gap: 8px;
  margin-bottom: 16px;
  position: relative; 

  @media (max-width: 500px) {
    font-size: 14px;
    padding: 0px 12px 24px 12px;
    gap: 0px;
    line-height: 24px;
 
  }

  ${GoalCard}:hover & {
    color: #FFFF56;
  }
`;

const ArrowButton = styled.div`
  position: absolute;
  line-height: 32px;
  bottom: 12px;
  right: 12px;
  color: #FFF56A;
  font-size: 24px;
  margin-right: 12px;
  z-index: 1; 

  @media (max-width: 500px) {
    margin-right: 0px;
  }
`;



const Goal = () => (
  <SectionWrapper>
    <Subtitle>Project Goals</Subtitle>
    <Title>計畫目標</Title>
    <GoalContainer>
      {/* Goal 1 */}
      <GoalCard>
        <GoalImage src="/images/Goal_DID.png" alt="Goal 1" />
        <GoalText>使用分散式身分識別驗證需求情境， 串接開源互通技術與臺灣憑證，建立臺灣數位民主創新示範。</GoalText>
        <a href="/did">
        <ArrowButton>&rarr;</ArrowButton>
        </a>
      </GoalCard>

      {/* Goal 2 */}
      <GoalCard>
        <GoalImage src="/images/Goal_DAO.png" alt="Goal 2" />
        <GoalText>彙整分散式自治組織的國內外研究知識及導入建議，積極透過活動向國內外社群推廣成果。</GoalText>
        <a href="/dao">
        <ArrowButton>&rarr;</ArrowButton>
        </a>
      </GoalCard>

      {/* Goal 3 */}
      <GoalCard>
        <GoalImage src="/images/Goal_RetroPGF.png" alt="Goal 3" />
        <GoalText>發展社會影響力資本生態系，挹注、激勵生產公共財的相關團體。</GoalText>
        <a href="retropgf">
        <ArrowButton>&rarr;</ArrowButton>
        </a>
      </GoalCard>

      {/* Goal 4 */}
      <GoalCard>
        <GoalImage src="/images/Goal_Web3.png" alt="Goal 4" />
        <GoalText>發展臺灣 Web3 的公民基礎設施之願景，並透過展覽與國際活動擴大與國際社群的合作。</GoalText>
        <a href="/web3">
        <ArrowButton>&rarr;</ArrowButton>
        </a>
      </GoalCard>
    </GoalContainer>
  </SectionWrapper>
);

export default Goal;
